<template>
  <nuxt-link
    class="notification-panel__notification-link"
    :to="route"
    @click="markAsReadAndHandleClick"
  >
    <div class="notification-panel__notification-content-title">
      <strong v-if="sender">{{ sender }}</strong>
      <strong v-else><s>Alguien</s></strong>
      comentó en
      <strong>{{ donde(notification.data) }}</strong>
    </div>
    <div
      v-if="notification.data.extracto"
      class="notification-panel__notification-content-description"
    >
      {{ notification.data.extracto }}
    </div>
  </nuxt-link>
</template>

<script>
import notificationContent from '@baserow/modules/core/mixins/notificationContent'

import { donde } from '@comentarios_mg/components/donde'

export default {
  name: 'AvisoComentario',
  mixins: [notificationContent],
  emits: ['close-panel'],
  methods: {
    donde,
    handleClick() {
      this.$emit('close-panel')
    },
  },
}
</script>
